// action
import {
    GET_CONTACT_US_ENQURIES_LIST,
    GET_CONTACT_US_ENQURIES_LIST_FAIL,
    GET_CONTACT_US_ENQURIES_LIST_SUCCESS,
    GET_CONTACT_US_ENQURIES_LIST_RESET
} from '../action/getContactUsEnquriesListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    list: [],
    pagination: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CONTACT_US_ENQURIES_LIST:
            return {
                ...state,
                apiState: "loading"
            }
     
        case GET_CONTACT_US_ENQURIES_LIST_SUCCESS:
            console.log("success", action)
            return {
                ...state,
                apiState: "success",
                list: action.response.data.data.result,
                pagination: action.response.data.data.pagination,
            }
        case GET_CONTACT_US_ENQURIES_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_CONTACT_US_ENQURIES_LIST_RESET:
            return initialState
        default:
            return state
    }
}